export default {
  name: "E808B2Triangle",
  props: {
    colors: {
      type: String,
      default: 'RGBRGBZXY'
    }
  },
  data() {
    return {
      flags: {
        'X': '+',
        'Y': '÷',
        'Z': '÷'
      },
      color: {
        'R': 'red',
        'G': 'green',
        'B': 'blue'
      }
    };
  },
  methods: {
    init() {}
  },
  mounted() {
    this.init();
  }
};